module.exports = __webpack_public_path__ + "assets/img/articleTitleBg.8dee6185.png";